<template>
    <b-modal
        title-tag="h2"
        title="Add Section"
        :lazy="true"
        :visible="isOpen"
        @close="close"
        @hidden="close"
    >
        <loader v-if="isLoadingList" />
        <div v-else>
            <div v-for="node in sectionLists" :key="node.id">
                <recursive-section
                    :ref="`recursive-section-${node.id}`"
                    class="pl-3"
                    :node="node"
                    :selectedSection="selectedSection"
                    module="patient"
                    @update-checkbox="updateCheckbox"
                />
            </div>
        </div>

        <template v-slot:modal-footer>
            <loader-saving v-if="isSaving" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isSaving"
            >
                Cancel
            </b-button>

            <b-button
                v-if="!isSaving"
                variant="primary"
                @click="add"
                :disabled="selectedSection.length == 0"
            >
                Add
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Loader from "@/components/elements/loader-list";
import LoaderSaving from "@/module/commons/loader";
import PatientSoapService from "@/services/patient/patient-soap";
import RecursiveSection from "@/components/soap/new-section-recursive.vue";
import { uniqBy, cloneDeep } from "lodash";

export default {
    components: {
        Loader,
        LoaderSaving,
        RecursiveSection
    },
    props: {},
    computed: {
        patientId() {
            return this.patientDetails ? this.patientDetails.id : null;
        },
        isSoap() {
            return this.$route.name === "soap";
        },
        soapDetails() {
            if (this.isSoap) {
                return this.$store.getters["soap/soapDetails"];
            } else {
                return null;
            }
        }
    },
    data() {
        return {
            isOpen: false,
            isLoadingList: true,
            sectionLists: {},
            isSaving: false,
            selectedSection: []
        };
    },
    watch: {},
    methods: {
        async open() {
            let self = this;
            self.isOpen = true;

            this.fetchSectionList();
        },
        close() {
            this.isOpen = false;
        },
        async fetchSectionList() {
            let self = this;
            const soapId = self.soapDetails?.id;

            if (soapId) {
                await PatientSoapService.getSoapSection(soapId)
                    .then(res => {
                        if (res && res.message && res.message.code == 200) {
                            self.sectionLists = res.resource.category;
                            // sort section by index
                            if (self.sectionLists.length > 0) {
                                self.sectionLists.sort(
                                    (a, b) => a.index - b.index
                                );
                            }
                        }
                    })
                    .catch(error => {
                        self._message(
                            "Error : Unable to get section information",
                            "danger"
                        );
                        console.error(error);
                    })
                    .finally(() => {
                        self.isLoadingList = false;
                    });
            }
        },
        async add() {
            let self = this;
            self.isSaving = true;

            const soapId = self.soapDetails?.id;
            const selectedSections = self.selectedSection.map(
                selectedSection => {
                    selectedSection.isactive = "1";
                    return selectedSection;
                }
            );

            try {
                await PatientSoapService.postSoapSection(soapId, {
                    data: selectedSections
                }).then(res => {
                    if (res && res.message && res.message.code == 200) {
                        self.isSaving = false;
                        self.close();
                        // reload tab medical note
                        self.$emit("reload");
                        self._message(
                            "Section(s) added successfully",
                            "success"
                        );
                    } else {
                        throw new Error("Unable to add section");
                    }
                });
            } catch (e) {
                console.log(e);
                self.isSaving = false;
                self._message("Error : Unable to added section", "danger");
            }
        },
        updateCheckbox(node) {
            if (node) {
                if (node.isChecked) {
                    this.selectedSection = this.selectedSection.concat(
                        node.elements
                    );
                    // Check array must not have duplicated node.id
                    this.selectedSection = uniqBy(this.selectedSection, "id");
                } else {
                    // Remove same selectedSection.id in selectedSection
                    this.selectedSection = this.selectedSection.filter(
                        item => !node.elements.some(node => node.id === item.id)
                    );
                }
            }
            // To update the checkbox status checked/unchecked
            this.$refs[`recursive-section-${node.parentId}`][0].updateInputKey(
                cloneDeep(this.selectedSection)
            );
        }
    }
};
</script>
